import React, { FC, useCallback } from 'react';

import { tokens } from '../../util/theme/fluent9';
import IconButton from '../IconButton';

import { AppLayoutContextValue } from './AppLayoutContextProvider.types';
import { SidebarPanelButtonProps } from './SidebarPanelButton.types';
import { useAppLayoutContext } from './hooks';

const SidebarPanelButton: FC<SidebarPanelButtonProps> = ({
  iconName = 'OpenPane',
  closeIconName = 'ClosePane',
  panelOpenIconColor,
}) => {
  const { openContentSidebarAriaLabel, openSidebarPanel, closeSidebarPanel, isSidebarPanelOpen } =
    useAppLayoutContext() as AppLayoutContextValue;
  const icon = isSidebarPanelOpen ? closeIconName : iconName;
  const toggleSidebarPanel = useCallback(() => {
    if (!isSidebarPanelOpen) {
      openSidebarPanel();
    } else {
      closeSidebarPanel();
    }
  }, [isSidebarPanelOpen, openSidebarPanel, closeSidebarPanel]);

  return (
    <IconButton
      size={32}
      ariaLabel={openContentSidebarAriaLabel}
      iconName={icon}
      backgroundHoverColor="neutralLighter"
      borderRadius={tokens.borderRadiusSmall}
      onClick={toggleSidebarPanel}
      className="qaSidebarPanelButton"
      color={isSidebarPanelOpen ? panelOpenIconColor : undefined}
    />
  );
};

export default SidebarPanelButton;
